<template>

    <div class="blueBg content">
        <div class="innerSlide">
            <h2>
                {{ $t('studies.page.' + datas.name) }}
                <a href="/studies-top" class="back pc" style="width: 239px;">
                    {{ $t('studies.page.back') }}
                </a>
            </h2>
            <div class="contentList">
                <template v-for="data in datas.datas">
                    <div class="contentItem">
                        <a :href="'/studies-detail?id=' + data.id + '&img=' + data.img + '&url=' + data.url +'&categoryId='+categoryId + '&categoryName='+datas.name" v-bind:style="{'background': 'url(./cai/common/images/info-screen/' + lang + '/' + data.img + ') center no-repeat'}">
                            <div class="title">{{ $t('studies.title.' + data.id) }}</div>
                        </a>
                    </div>
                </template>
            </div>

            <a href="/studies-top" class="back sp">
                {{ $t('studies.page.back') }}
            </a>
        </div>
    </div>

</template>


<script>
    import languageService from "../../services/LanguageService";
    import StudiesService from '../../services/StudiesService';

    export default {
        name: 'studies-category',

        components: {
        },

        data() {
            return {
                datas: {
                    name: 'recommended'
                },
                isAuth: false,
                isOpenImg01Modal: false,
                isOpenImg02Modal: false,
                lang: 'en',
                categoryId: ''
            }
        },

        async created() {
            this.lang = languageService.getCurrentLanguageShortCode();
            var datas = await StudiesService.getCategorySingle(this.$route.query.id)
            this.datas = datas.data;
            this.categoryId = this.$route.query.id;
        },

        methods: {
        },

        async mounted() {
            this.$nextTick(function () {
            })
        }
    }
</script>

<style lang="sass" scoped>
    @import "./assets/css/slick.scss"
    @import "./assets/css/style.scss"
</style>
